import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-h4 font-weight-bold mb-2" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "text-h6 font-weight-bold" }
const _hoisted_4 = { class: "text-caption text-grey-darken-1" }
const _hoisted_5 = { class: "info-section mb-4" }
const _hoisted_6 = { class: "info-item" }
const _hoisted_7 = { class: "text-body-2 font-weight-medium" }
const _hoisted_8 = { class: "info-item" }
const _hoisted_9 = { class: "text-body-2 font-weight-medium" }
const _hoisted_10 = { class: "info-item" }
const _hoisted_11 = { class: "text-body-2 font-weight-medium" }
const _hoisted_12 = { class: "info-item" }
const _hoisted_13 = { class: "text-body-2 font-weight-medium" }
const _hoisted_14 = { class: "d-flex align-center" }
const _hoisted_15 = { class: "text-caption" }
const _hoisted_16 = {
  key: 0,
  class: "ml-1 font-weight-bold"
}
const _hoisted_17 = { class: "text-caption" }
const _hoisted_18 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_19 = { class: "text-caption text-grey-darken-1 text-center" }
const _hoisted_20 = { class: "text-h6 mb-4" }
const _hoisted_21 = {
  key: 0,
  class: "text-center pa-6"
}
const _hoisted_22 = { class: "d-flex align-center" }
const _hoisted_23 = { class: "text-h6 font-weight-bold" }
const _hoisted_24 = { class: "text-h6 font-weight-bold" }
const _hoisted_25 = {
  key: 0,
  class: "text-caption text-grey-darken-1"
}
const _hoisted_26 = { class: "items-summary" }
const _hoisted_27 = { class: "text-caption text-grey-darken-1 mt-2" }
const _hoisted_28 = { class: "d-flex justify-space-between mb-2" }
const _hoisted_29 = { class: "text-body-2 font-weight-medium" }
const _hoisted_30 = {
  key: 0,
  class: "d-flex justify-space-between mb-2 text-red"
}
const _hoisted_31 = { class: "text-body-2" }
const _hoisted_32 = { class: "d-flex justify-space-between" }
const _hoisted_33 = { class: "text-h6 font-weight-bold text-success" }
const _hoisted_34 = { class: "text-h6 mb-3 d-flex align-center" }
const _hoisted_35 = { class: "text-subtitle-1 mb-2 d-flex align-center" }
const _hoisted_36 = { class: "text-caption text-grey-darken-1" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = {
  key: 0,
  class: "ml-2 text-caption"
}
const _hoisted_39 = { class: "text-body-2 font-weight-bold" }

import { ref, onMounted, computed, onActivated } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { generatePDFOptions as generatePDFUtilOptions, type PdfData } from '@/utils/pdfGenerator-opciones'
import { loadImageBase64 } from '@/utils/constantes'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'cotizacionOpciones'
},
  __name: 'cotizacionOpciones',
  setup(__props) {



const router = useRouter()
const store = useStore()

const route = useRoute()  // agregar junto a router y store

const reloadDialog = ref(false)

// ============================================================================
// STATE
// ============================================================================

const saving = ref(false)

const loading = ref(false)
const loadingDetails = ref(false)
const opcionesList = ref<any[]>([])
const tiposEvento = ref<any[]>([])

const filters = ref({
  search: '',
  estado: null,
  tipoEvento: null
})

const estadosOptions = [
  { title: 'Pendiente', value: 'Pendiente' },
  { title: 'Seleccionada', value: 'Seleccionada' },
  { title: 'Rechazada', value: 'Rechazada' },
  { title: 'Expirada', value: 'Expirada' }
]

const detailsModal = ref(false)
const fullDetailsModal = ref(false)
const selectedOpcion = ref<any>(null)
const selectedFullOption = ref<any>(null)
const detailsOptions = ref<any[]>([])
const detailsOption = ref<any>(null)
const detailsItems = ref<any[]>([])

const snackbar = ref({
  show: false,
  message: '',
  color: 'success'
})

const toast = ref({
  show: false,
  message: '',
  type: 'success'
})

let searchTimeout: any = null

// ============================================================================
// COMPUTED
// ============================================================================

const filteredOpciones = computed(() => {
  return opcionesList.value
})

// ============================================================================
// METHODS
// ============================================================================

async function loadOpciones() {
  try {
    loading.value = true
    await store.dispatch('Cotizacion/getOpcionesCotizacionList', filters.value)
    opcionesList.value = store.state.Cotizacion.OpcionesCotizacionList?.data?.data || []
  } catch (error) {
    showSnackbar('Error al cargar las opciones', 'error')
  } finally {
    loading.value = false
  }
}

async function loadTiposEvento() {
  try {
    await store.dispatch('Cotizacion/getTiposEvento')
    tiposEvento.value = store.state.Cotizacion.TiposEvento?.data?.data || []
  } catch (error) {
    console.error('Error cargando tipos de evento:', error)
  }
}

function debouncedSearch() {
  clearTimeout(searchTimeout)
  searchTimeout = setTimeout(() => {
    loadOpciones()
  }, 500)
}

async function openDetailsModal(opcion: any) {
  selectedOpcion.value = opcion
  detailsModal.value = true
  
  // Cargar detalles de las opciones
  try {
    loadingDetails.value = true
    
    // Aquí deberías tener un endpoint específico para obtener los detalles
    // Por ahora simulamos con los datos que tienes
    await store.dispatch('Cotizacion/getOpcionCotizacionDetails', opcion.OpcionCotizacionID)
    detailsOptions.value =store.state.Cotizacion.OpcionCotizacionDetails?.data?.data?.options || []
    detailsOption.value =store.state.Cotizacion.OpcionCotizacionDetails?.data?.data?.opcion || []
    detailsItems.value =store.state.Cotizacion.OpcionCotizacionDetails?.data?.data?.items || []
    
    
  } catch (error) {
    showSnackbar('Error al cargar detalles', 'error')
  } finally {
    loadingDetails.value = false
  }
}

function closeDetailsModal() {
  detailsModal.value = false
  selectedOpcion.value = null
  detailsOptions.value = []
  detailsItems.value = []
}

function viewFullOptionDetails(option: any) {
  selectedFullOption.value = option
  fullDetailsModal.value = true
}

function getClientLink(opcion: any) {
  const baseUrl = window.location.origin
  return `${baseUrl}/opciones-cotizacion/${opcion.TokenAcceso}`
}

function copyToClipboard(text: string) {
  navigator.clipboard.writeText(text)
  showSnackbar('Enlace copiado al portapapeles', 'success')
}

function sendByEmail(opcion: any) {
  const link = getClientLink(opcion)
  const subject = `Opciones de Cotización - ${opcion.CodigoOpcion}`
  const body = `Estimado/a ${opcion.NombreCliente},\n\nHemos preparado ${opcion.NumeroOpciones} opciones para su evento.\n\nPuede revisarlas en el siguiente enlace:\n${link}\n\nVálido hasta: ${formatDateTime(opcion.FechaExpiracion)}\n\nSaludos cordiales.`
  
  window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`
}

function sendByWhatsApp(opcion: any) {
  const link = getClientLink(opcion)
  const message = `¡Hola ${opcion.NombreCliente}! 👋\n\nHemos preparado ${opcion.NumeroOpciones} opciones especiales para tu evento.\n\n🔗 Revísalas aquí: ${link}\n\n⏰ Válido hasta: ${formatDateTime(opcion.FechaExpiracion)}\n\n¡Esperamos tu respuesta!`
  
  window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, '_blank')
}

function goToCotizacion(cotizacionID: number) {
  router.push(`/cotizacion/${cotizacionID}`)
}

function goToCreateOptions() {
  router.push('/cotizaciones/new')
}

async function extendExpiration(opcion: any) {
  try {
    await store.dispatch('Cotizacion/extenderExpiracionOpcion', {
      opcionCotizacionID: opcion.OpcionCotizacionID,
      dias: 7
    })
    showSnackbar('Expiración extendida 7 días', 'success')
    loadOpciones()
    closeDetailsModal()
  } catch (error) {
    showSnackbar('Error al extender expiración', 'error')
  }
}

function getServicesSummary(detalleOpcionID: number) {
  const items = detailsItems.value.filter(item => item.DetalleOpcionID === detalleOpcionID)
  const services = new Map<string, number>()

  items.forEach(item => {
    const count = services.get(item.NombreServicio) || 0
    services.set(item.NombreServicio, count + (item.Cantidad || 1))
  })

  return Array.from(services.entries()).map(([name, count]) => ({ name, count }))
}

function getOptionItemsCount(detalleOpcionID: number) {
  return detailsItems.value
    .filter(item => item.DetalleOpcionID === detalleOpcionID)
    .reduce((sum: number, item: any) => sum + (item.Cantidad || 1), 0)
}

function getItemsGroupedByService(detalleOpcionID: number) {
  const items = detailsItems.value.filter(item => item.DetalleOpcionID === detalleOpcionID)
  const grouped: any = {}
  
  items.forEach(item => {
    if (!grouped[item.NombreServicio]) {
      grouped[item.NombreServicio] = {}
    }
    if (!grouped[item.NombreServicio][item.NombreSeccion]) {
      grouped[item.NombreServicio][item.NombreSeccion] = []
    }
    grouped[item.NombreServicio][item.NombreSeccion].push(item)
  })
  
  return grouped
}

function formatDate(dateString: string) {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleDateString('es-CO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  })
}

function formatDateTime(dateString: string) {
  if (!dateString) return '-'
  return new Date(dateString).toLocaleString('es-CO', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

function formatCurrency(value: number | string) {
  if (typeof value === 'string') {
    value = parseFloat(value)
  }
  return new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    minimumFractionDigits: 0
  }).format(value || 0)
}

function getStatusColor(status: string) {
  const colors: any = {
    'Pendiente': 'warning',
    'Seleccionada': 'success',
    'Rechazada': 'error',
    'Expirada': 'grey'
  }
  return colors[status] || 'grey'
}

function getStatusIcon(status: string) {
  const icons: any = {
    'Pendiente': 'mdi-clock-outline',
    'Seleccionada': 'mdi-check-circle',
    'Rechazada': 'mdi-close-circle',
    'Expirada': 'mdi-timer-off'
  }
  return icons[status] || 'mdi-help-circle'
}

function getExpirationType(opcion: any) {
  if (opcion.Expirada) return 'error'
  if (isExpiringSoon(opcion)) return 'warning'
  return 'info'
}

function isExpiringSoon(opcion: any) {
  if (!opcion.FechaExpiracion) return false
  const expiration = new Date(opcion.FechaExpiracion)
  const now = new Date()
  const diffHours = (expiration.getTime() - now.getTime()) / (1000 * 60 * 60)
  return diffHours > 0 && diffHours < 48
}

function showSnackbar(message: string, color = 'success') {
  snackbar.value = { show: true, message, color }
}

function selectOption(option: any) {
  saveQuotation(option)
}

function getPendingAmount(option: any) {
  return Number.parseFloat(option.TotalConDescuento) // - Number.parseFloat(option.TotalPagado)
}

function getItemsByService(detalleOpcionID: number, option: any) {
  const items = detailsItems.value.filter(item => item.DetalleOpcionID === detalleOpcionID)
  return items
}

  async function saveQuotation(option: any) {
    if(!confirm('¿Está seguro de guardar esta cotización? esto eliminara la cotización de la lista de opciones.')) return
        // TODO: agregar un modal para confirmar la cotización
    try {
      const itemsGroupedByService = getItemsByService(option.DetalleOpcionID, option) 
      saving.value = true
      await store.dispatch('Cotizacion/fetchCatalogo')

      const pdfDataOption = JSON.parse(detailsOption.value.PdfData) || []
      const dataOption = pdfDataOption.selectedItems.find((item: any) => item.nombre === option.NombreOpcion)
      const { servicios } = store.state.Cotizacion.Catalogo.data.data
      const pdfData: PdfData = {
        nombreCliente: selectedOpcion.value.NombreCliente,
        tipoEvento: selectedOpcion.value.TipoEvento,
        selectedItems: dataOption.selectedItems,
        catalogoServicios: servicios,
        eventDate: selectedOpcion.value.FechaEvento,
        guestCount: detailsOption.value.NumeroInvitados,
        discountPercent: detailsOption.value.PorcentajeDescuento,
        discountAmount: Number.parseFloat(option.MontoDescuento),
        subtotal: Number.parseFloat(option.Subtotal),
        totalWithDiscount: Number.parseFloat(option.TotalConDescuento),
        payments: [{ amount: 0 }],
        pendingAmount: getPendingAmount(option),
        observations: '',
        backgroundRespage: await loadImageBase64('/pdf/bk_pdf.png'),
        backgroundHeader: await loadImageBase64('/pdf/header.png'),
        signatureImage: await loadImageBase64('/pdf/firma.png')
      }
      const payload = {
        NombreCliente: selectedOpcion.value.NombreCliente,
        TipoEventoID: detailsOption.value.TipoEventoID,
        FechaEvento: selectedOpcion.value.FechaEvento,
        NumeroInvitados: selectedOpcion.value.NumeroInvitados,
        PorcentajeDescuento: Number(detailsOption.value.PorcentajeDescuento),
        Observaciones: selectedOpcion.value.Observaciones || '',
        PdfData: JSON.stringify(pdfData),
        items: itemsGroupedByService.map(item => ({
          itemID: item.ItemID,
          cantidad: item.Cantidad,
          observaciones: item.Observaciones
        })),
        abonos: []
      }
      await store.dispatch('Cotizacion/createCotizacion', payload)
      const result = store.state.Cotizacion.result
      if (result.success) {
        await store.dispatch('Cotizacion/deleteCotizacion', option.OpcionCotizacionID)
      }
      await loadOpciones() 
      fullDetailsModal.value = false
      detailsModal.value = false
      loadingDetails.value = false
      goToList()
    } catch (error: any) {
      console.error('Error guardando cotización:', error)
      showToast(error.response?.data?.message || 'Error al guardar la cotización', 'error')
    } finally {
      saving.value = false
    }
  }

  function showToast(message: string, type = 'success') {
  toast.value = { show: true, message, type }
}
function goToList() {
  router.push({ path: '/cotizaciones/list', query: { from: 'opciones' } })
}
async function generatePdf() {
  saving.value = true
  try {
    
    const pdfDataOption = JSON.parse(detailsOption.value.PdfData) || []
    const pdfData: PdfData = {
      nombreCliente: pdfDataOption.nombreCliente,
      tipoEvento: pdfDataOption.tipoEvento || '',
      eventDate: pdfDataOption.eventDate,
      guestCount: pdfDataOption.guestCount || 0,
      discountPercent: pdfDataOption.discountPercent || 0,
      observations: pdfDataOption.observations || '',
      opciones: pdfDataOption.opciones,  
      catalogoServicios: pdfDataOption.catalogoServicios,
      payments: pdfDataOption.payments,
      pendingAmount: pdfDataOption.pendingAmount,
      selectedItems: [],
      subtotal: pdfDataOption.subtotal,
      discountAmount: pdfDataOption.discountAmount,
      totalWithDiscount: pdfDataOption.totalWithDiscount,
      backgroundRespage: pdfDataOption.backgroundRespage,
      backgroundHeader: pdfDataOption.backgroundHeader,
      signatureImage: pdfDataOption.signatureImage
    }
    
    await generatePDFUtilOptions(pdfData)
    showToast('✅ PDF generado exitosamente')
  } catch (error) {
    console.error('Error generando PDF:', error)
    showToast('Error al generar el PDF', 'error')
  } finally {
    saving.value = false
  }
}

async function deleteOption(option: any) {
    if(!confirm('¿Está seguro de eliminar la opción?')) return
  try {
      await store.dispatch('Cotizacion/eliminarOpcionCotizacion', option)
      const result = store.state.Cotizacion.result
      if (result.success) {
        loadOpciones()
      } else {
        showToast('Error al eliminar la opción', 'error')
      }
  } catch (error) {
    showToast('Error al eliminar la opción', 'error')
  }
}

// ============================================================================
// LIFECYCLE
// ============================================================================

onMounted(() => {
  loadOpciones()
  loadTiposEvento()
})

onActivated(() => {
  // Si viene desde cotizacionNew, preguntar si quiere recargar
  if (route.query.from === 'new') {
    reloadDialog.value = true
    // Limpiar el query para que no vuelva a dispararse si navega entre tabs
    router.replace({ query: {} })
  }
})
function confirmReload() {
  reloadDialog.value = false
  loadOpciones()
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    fluid: "",
    class: "opciones-cotizacion-list-view"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, {
        class: "mb-6 header-card",
        elevation: "8"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-8" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "8"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("h1", _hoisted_1, [
                        _createVNode(_component_v_icon, {
                          size: "40",
                          color: "white"
                        }, {
                          default: _withCtx(() => _cache[16] || (_cache[16] = [
                            _createTextVNode("mdi-folder-star")
                          ])),
                          _: 1,
                          __: [16]
                        }),
                        _cache[17] || (_cache[17] = _createTextVNode(" Cotizaciones Pendientes "))
                      ]),
                      _cache[18] || (_cache[18] = _createElementVNode("p", { class: "text-h6 mb-0 subtitle" }, "Gestiona las cotizaciones enviadas a tus clientes", -1))
                    ]),
                    _: 1,
                    __: [18]
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4",
                    class: "text-right"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "white",
                        variant: "outlined",
                        size: "large",
                        "prepend-icon": "mdi-plus-circle",
                        onClick: goToCreateOptions
                      }, {
                        default: _withCtx(() => _cache[19] || (_cache[19] = [
                          _createTextVNode(" Nueva Cotización ")
                        ])),
                        _: 1,
                        __: [19]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_card, {
        class: "mb-6",
        elevation: "4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_text, { class: "pa-4" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, { align: "center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        modelValue: filters.value.search,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.value.search) = $event)),
                        label: "Buscar cliente o código",
                        placeholder: "Buscar...",
                        variant: "outlined",
                        density: "compact",
                        "prepend-inner-icon": "mdi-magnify",
                        clearable: "",
                        "hide-details": "",
                        onInput: debouncedSearch
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: filters.value.estado,
                        "onUpdate:modelValue": [
                          _cache[1] || (_cache[1] = ($event: any) => ((filters.value.estado) = $event)),
                          loadOpciones
                        ],
                        items: estadosOptions,
                        label: "Estado",
                        variant: "outlined",
                        density: "compact",
                        clearable: "",
                        "hide-details": ""
                      }, {
                        selection: _withCtx(({ item }) => [
                          _createVNode(_component_v_chip, {
                            color: getStatusColor(item.value),
                            size: "small"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(item.title), 1)
                            ]),
                            _: 2
                          }, 1032, ["color"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "3"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_select, {
                        modelValue: filters.value.tipoEvento,
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => ((filters.value.tipoEvento) = $event)),
                          loadOpciones
                        ],
                        items: tiposEvento.value,
                        "item-title": "NombreTipo",
                        "item-value": "TipoEventoID",
                        label: "Tipo de Evento",
                        variant: "outlined",
                        density: "compact",
                        clearable: "",
                        "hide-details": ""
                      }, null, 8, ["modelValue", "items"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    md: "2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "primary",
                        block: "",
                        "prepend-icon": "mdi-refresh",
                        onClick: loadOpciones
                      }, {
                        default: _withCtx(() => _cache[20] || (_cache[20] = [
                          _createTextVNode(" Actualizar ")
                        ])),
                        _: 1,
                        __: [20]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (loading.value)
        ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                return _createVNode(_component_v_col, {
                  key: `skeleton-${i}`,
                  cols: "12",
                  md: "6",
                  lg: "4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_skeleton_loader, { type: "card" })
                  ]),
                  _: 2
                }, 1024)
              }), 64))
            ]),
            _: 1
          }))
        : (opcionesList.value.length > 0)
          ? (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(opcionesList.value, (opcion) => {
                  return (_openBlock(), _createBlock(_component_v_col, {
                    key: opcion.OpcionCotizacionID,
                    cols: "12",
                    md: "6",
                    lg: "4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_card, {
                        class: _normalizeClass(['opcion-card', { 'expired': opcion.Expirada }]),
                        elevation: "3",
                        hover: "",
                        onClick: ($event: any) => (openDetailsModal(opcion))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_card_title, { class: "pa-4 d-flex align-center justify-space-between bg-grey-lighten-4" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_2, [
                                _createVNode(_component_v_avatar, {
                                  color: "primary",
                                  size: "40",
                                  class: "mr-3"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { color: "white" }, {
                                      default: _withCtx(() => _cache[21] || (_cache[21] = [
                                        _createTextVNode("mdi-account")
                                      ])),
                                      _: 1,
                                      __: [21]
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createElementVNode("div", null, [
                                  _createElementVNode("div", _hoisted_3, _toDisplayString(opcion.NombreCliente), 1),
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(opcion.CodigoOpcion), 1)
                                ])
                              ]),
                              _createVNode(_component_v_chip, {
                                color: getStatusColor(opcion.EstadoOpcion),
                                size: "small",
                                variant: "flat"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    start: "",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getStatusIcon(opcion.EstadoOpcion)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createTextVNode(" " + _toDisplayString(opcion.EstadoOpcion), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_text, { class: "pa-4" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_5, [
                                _createVNode(_component_v_row, { dense: "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_6, [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            color: "primary",
                                            class: "mr-1"
                                          }, {
                                            default: _withCtx(() => _cache[22] || (_cache[22] = [
                                              _createTextVNode("mdi-party-popper")
                                            ])),
                                            _: 1,
                                            __: [22]
                                          }),
                                          _cache[23] || (_cache[23] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Tipo:", -1)),
                                          _createElementVNode("div", _hoisted_7, _toDisplayString(opcion.TipoEvento || 'General'), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_8, [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            color: "primary",
                                            class: "mr-1"
                                          }, {
                                            default: _withCtx(() => _cache[24] || (_cache[24] = [
                                              _createTextVNode("mdi-calendar")
                                            ])),
                                            _: 1,
                                            __: [24]
                                          }),
                                          _cache[25] || (_cache[25] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Fecha:", -1)),
                                          _createElementVNode("div", _hoisted_9, _toDisplayString(formatDate(opcion.FechaEvento)), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_10, [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            color: "primary",
                                            class: "mr-1"
                                          }, {
                                            default: _withCtx(() => _cache[26] || (_cache[26] = [
                                              _createTextVNode("mdi-account-group")
                                            ])),
                                            _: 1,
                                            __: [26]
                                          }),
                                          _cache[27] || (_cache[27] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Invitados:", -1)),
                                          _createElementVNode("div", _hoisted_11, _toDisplayString(opcion.NumeroInvitados), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_v_col, { cols: "6" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_12, [
                                          _createVNode(_component_v_icon, {
                                            size: "small",
                                            color: "primary",
                                            class: "mr-1"
                                          }, {
                                            default: _withCtx(() => _cache[28] || (_cache[28] = [
                                              _createTextVNode("mdi-format-list-numbered")
                                            ])),
                                            _: 1,
                                            __: [28]
                                          }),
                                          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "text-caption text-grey-darken-1" }, "Opciones:", -1)),
                                          _createElementVNode("div", _hoisted_13, _toDisplayString(opcion.NumeroOpciones), 1)
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              (opcion.FechaExpiracion && false)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 0,
                                    type: getExpirationType(opcion),
                                    variant: "tonal",
                                    density: "compact",
                                    class: "mb-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_14, [
                                        _createVNode(_component_v_icon, {
                                          start: "",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[30] || (_cache[30] = [
                                            _createTextVNode("mdi-clock-outline")
                                          ])),
                                          _: 1,
                                          __: [30]
                                        }),
                                        _createElementVNode("div", _hoisted_15, [
                                          _cache[31] || (_cache[31] = _createElementVNode("strong", null, "Expira:", -1)),
                                          _createTextVNode(" " + _toDisplayString(formatDateTime(opcion.FechaExpiracion)) + " ", 1),
                                          (isExpiringSoon(opcion))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_16, " (¡Pronto!) "))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["type"]))
                                : _createCommentVNode("", true),
                              (opcion.OpcionSeleccionada)
                                ? (_openBlock(), _createBlock(_component_v_alert, {
                                    key: 1,
                                    type: "success",
                                    variant: "tonal",
                                    density: "compact",
                                    class: "mb-3"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_17, [
                                        _createVNode(_component_v_icon, {
                                          start: "",
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => _cache[32] || (_cache[32] = [
                                            _createTextVNode("mdi-check-circle")
                                          ])),
                                          _: 1,
                                          __: [32]
                                        }),
                                        _cache[34] || (_cache[34] = _createElementVNode("strong", null, "Seleccionó:", -1)),
                                        _createTextVNode(" " + _toDisplayString(opcion.OpcionSeleccionada) + " ", 1),
                                        (opcion.NumeroCotizacion)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                              _cache[33] || (_cache[33] = _createElementVNode("strong", null, "Cotización:", -1)),
                                              _createTextVNode(" " + _toDisplayString(opcion.NumeroCotizacion), 1)
                                            ]))
                                          : _createCommentVNode("", true)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_v_icon, { size: "small" }, {
                                  default: _withCtx(() => _cache[35] || (_cache[35] = [
                                    _createTextVNode("mdi-calendar-clock")
                                  ])),
                                  _: 1,
                                  __: [35]
                                }),
                                _createTextVNode(" Creada el " + _toDisplayString(formatDateTime(opcion.FechaCreacion)), 1)
                              ])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_v_card_actions, { class: "pa-4 pt-0" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_row, { dense: "" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        color: "primary",
                                        variant: "tonal",
                                        size: "small",
                                        block: "",
                                        "prepend-icon": "mdi-eye",
                                        onClick: _withModifiers(($event: any) => (openDetailsModal(opcion)), ["stop"])
                                      }, {
                                        default: _withCtx(() => _cache[36] || (_cache[36] = [
                                          _createTextVNode(" Ver Detalles ")
                                        ])),
                                        _: 2,
                                        __: [36]
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, { cols: "12" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_btn, {
                                        color: "error",
                                        variant: "text",
                                        size: "small",
                                        block: "",
                                        "prepend-icon": "mdi-delete",
                                        onClick: _withModifiers(($event: any) => (deleteOption(opcion)), ["stop"])
                                      }, {
                                        default: _withCtx(() => _cache[37] || (_cache[37] = [
                                          _createTextVNode(" Eliminar Opción ")
                                        ])),
                                        _: 2,
                                        __: [37]
                                      }, 1032, ["onClick"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["class", "onClick"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_card, {
              key: 2,
              class: "text-center pa-10",
              elevation: "2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "80",
                  color: "grey-lighten-1"
                }, {
                  default: _withCtx(() => _cache[38] || (_cache[38] = [
                    _createTextVNode("mdi-folder-open")
                  ])),
                  _: 1,
                  __: [38]
                }),
                _cache[40] || (_cache[40] = _createElementVNode("h3", { class: "text-h5 text-grey mt-4 mb-2" }, "No hay opciones de cotización", -1)),
                _cache[41] || (_cache[41] = _createElementVNode("p", { class: "text-body-1 text-grey-darken-1 mb-4" }, " Crea nuevas opciones para que tus clientes elijan la mejor alternativa ", -1)),
                _createVNode(_component_v_btn, {
                  color: "primary",
                  size: "large",
                  "prepend-icon": "mdi-plus",
                  onClick: goToCreateOptions
                }, {
                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                    _createTextVNode(" Crear Opciones de Cotización ")
                  ])),
                  _: 1,
                  __: [39]
                })
              ]),
              _: 1,
              __: [40,41]
            })),
      _createVNode(_component_v_dialog, {
        modelValue: detailsModal.value,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((detailsModal).value = $event)),
        "max-width": "1400",
        scrollable: "",
        persistent: ""
      }, {
        default: _withCtx(() => [
          (selectedOpcion.value)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar, {
                    color: "primary",
                    dark: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => _cache[42] || (_cache[42] = [
                              _createTextVNode("mdi-folder-information")
                            ])),
                            _: 1,
                            __: [42]
                          }),
                          _createTextVNode(" " + _toDisplayString(selectedOpcion.value.CodigoOpcion) + " - " + _toDisplayString(selectedOpcion.value.NombreCliente), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_chip, {
                        color: getStatusColor(selectedOpcion.value.EstadoOpcion),
                        variant: "flat",
                        class: "mr-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(selectedOpcion.value.EstadoOpcion), 1)
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        onClick: closeDetailsModal
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                              _createTextVNode("mdi-close")
                            ])),
                            _: 1,
                            __: [43]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, {
                    class: "pa-6",
                    style: {"max-height":"70vh"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "4"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                variant: "outlined",
                                class: "mb-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "text-subtitle-1 bg-grey-lighten-4 pa-3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        start: "",
                                        color: "primary"
                                      }, {
                                        default: _withCtx(() => _cache[44] || (_cache[44] = [
                                          _createTextVNode("mdi-account-circle")
                                        ])),
                                        _: 1,
                                        __: [44]
                                      }),
                                      _cache[45] || (_cache[45] = _createTextVNode(" Información del Cliente "))
                                    ]),
                                    _: 1,
                                    __: [45]
                                  }),
                                  _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, { density: "compact" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                default: _withCtx(() => _cache[46] || (_cache[46] = [
                                                  _createTextVNode("Cliente")
                                                ])),
                                                _: 1,
                                                __: [46]
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 font-weight-bold" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(selectedOpcion.value.NombreCliente), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                default: _withCtx(() => _cache[47] || (_cache[47] = [
                                                  _createTextVNode("Tipo de Evento")
                                                ])),
                                                _: 1,
                                                __: [47]
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(selectedOpcion.value.TipoEvento || 'General'), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                default: _withCtx(() => _cache[48] || (_cache[48] = [
                                                  _createTextVNode("Fecha del Evento")
                                                ])),
                                                _: 1,
                                                __: [48]
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(formatDate(selectedOpcion.value.FechaEvento)), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                default: _withCtx(() => _cache[49] || (_cache[49] = [
                                                  _createTextVNode("Invitados")
                                                ])),
                                                _: 1,
                                                __: [49]
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(selectedOpcion.value.NumeroInvitados), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              false
                                ? (_openBlock(), _createBlock(_component_v_card, {
                                    key: 0,
                                    variant: "outlined",
                                    class: "mb-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_card_title, { class: "text-subtitle-1 bg-grey-lighten-4 pa-3" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_icon, {
                                            start: "",
                                            color: "primary"
                                          }, {
                                            default: _withCtx(() => _cache[50] || (_cache[50] = [
                                              _createTextVNode("mdi-link")
                                            ])),
                                            _: 1,
                                            __: [50]
                                          }),
                                          _cache[51] || (_cache[51] = _createTextVNode(" Enlace para el Cliente "))
                                        ]),
                                        _: 1,
                                        __: [51]
                                      }),
                                      _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_text_field, {
                                            "model-value": getClientLink(selectedOpcion.value),
                                            readonly: "",
                                            variant: "outlined",
                                            density: "compact",
                                            "hide-details": ""
                                          }, {
                                            append: _withCtx(() => [
                                              _createVNode(_component_v_btn, {
                                                icon: "mdi-content-copy",
                                                variant: "text",
                                                size: "small",
                                                onClick: _cache[3] || (_cache[3] = ($event: any) => (copyToClipboard(getClientLink(selectedOpcion.value))))
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["model-value"]),
                                          _createVNode(_component_v_btn, {
                                            color: "primary",
                                            variant: "tonal",
                                            block: "",
                                            class: "mt-3",
                                            "prepend-icon": "mdi-email",
                                            size: "small",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (sendByEmail(selectedOpcion.value)))
                                          }, {
                                            default: _withCtx(() => _cache[52] || (_cache[52] = [
                                              _createTextVNode(" Enviar por Email ")
                                            ])),
                                            _: 1,
                                            __: [52]
                                          }),
                                          _createVNode(_component_v_btn, {
                                            color: "success",
                                            variant: "tonal",
                                            block: "",
                                            class: "mt-2",
                                            "prepend-icon": "mdi-whatsapp",
                                            size: "small",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (sendByWhatsApp(selectedOpcion.value)))
                                          }, {
                                            default: _withCtx(() => _cache[53] || (_cache[53] = [
                                              _createTextVNode(" Enviar por WhatsApp ")
                                            ])),
                                            _: 1,
                                            __: [53]
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_card, { variant: "outlined" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_card_title, { class: "text-subtitle-1 bg-grey-lighten-4 pa-3" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, {
                                        start: "",
                                        color: "primary"
                                      }, {
                                        default: _withCtx(() => _cache[54] || (_cache[54] = [
                                          _createTextVNode("mdi-information")
                                        ])),
                                        _: 1,
                                        __: [54]
                                      }),
                                      _cache[55] || (_cache[55] = _createTextVNode(" Estado "))
                                    ]),
                                    _: 1,
                                    __: [55]
                                  }),
                                  _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, { density: "compact" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_list_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                default: _withCtx(() => _cache[56] || (_cache[56] = [
                                                  _createTextVNode("Estado")
                                                ])),
                                                _: 1,
                                                __: [56]
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_chip, {
                                                    color: getStatusColor(selectedOpcion.value.EstadoOpcion),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(selectedOpcion.value.EstadoOpcion), 1)
                                                    ]),
                                                    _: 1
                                                  }, 8, ["color"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_list_item, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                default: _withCtx(() => _cache[57] || (_cache[57] = [
                                                  _createTextVNode("Creada")
                                                ])),
                                                _: 1,
                                                __: [57]
                                              }),
                                              _createVNode(_component_v_list_item_subtitle, { class: "text-body-2" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode(_toDisplayString(formatDateTime(selectedOpcion.value.FechaCreacion)), 1)
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          (selectedOpcion.value.FechaExpiracion)
                                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 0 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                    default: _withCtx(() => _cache[58] || (_cache[58] = [
                                                      _createTextVNode("Expira")
                                                    ])),
                                                    _: 1,
                                                    __: [58]
                                                  }),
                                                  _createVNode(_component_v_list_item_subtitle, { class: "text-body-2" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(formatDateTime(selectedOpcion.value.FechaExpiracion)), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true),
                                          (selectedOpcion.value.OpcionSeleccionada)
                                            ? (_openBlock(), _createBlock(_component_v_list_item, { key: 1 }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item_title, { class: "text-caption text-grey-darken-1" }, {
                                                    default: _withCtx(() => _cache[59] || (_cache[59] = [
                                                      _createTextVNode("Opción Seleccionada")
                                                    ])),
                                                    _: 1,
                                                    __: [59]
                                                  }),
                                                  _createVNode(_component_v_list_item_subtitle, { class: "text-body-2 text-success font-weight-bold" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(selectedOpcion.value.OpcionSeleccionada), 1)
                                                    ]),
                                                    _: 1
                                                  })
                                                ]),
                                                _: 1
                                              }))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_col, {
                            cols: "12",
                            md: "8"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", _hoisted_20, [
                                _createVNode(_component_v_icon, {
                                  color: "primary",
                                  class: "mr-2"
                                }, {
                                  default: _withCtx(() => _cache[60] || (_cache[60] = [
                                    _createTextVNode("mdi-format-list-checks")
                                  ])),
                                  _: 1,
                                  __: [60]
                                }),
                                _createTextVNode(" Opciones Presentadas (" + _toDisplayString(detailsOptions.value.length) + ") ", 1)
                              ]),
                              (loadingDetails.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createVNode(_component_v_progress_circular, {
                                      indeterminate: "",
                                      color: "primary",
                                      size: "64"
                                    }),
                                    _cache[61] || (_cache[61] = _createElementVNode("p", { class: "text-body-1 text-grey mt-4" }, "Cargando opciones...", -1))
                                  ]))
                                : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detailsOptions.value, (option) => {
                                        return (_openBlock(), _createBlock(_component_v_col, {
                                          key: option.DetalleOpcionID,
                                          cols: "12"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                              class: _normalizeClass(['option-detail-card', { 'selected-option': option.EsSeleccionada }]),
                                              elevation: "2"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "pa-4 bg-grey-lighten-4 d-flex align-center justify-space-between" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("div", _hoisted_22, [
                                                      _createVNode(_component_v_avatar, {
                                                        color: option.EsSeleccionada ? 'success' : 'primary',
                                                        size: "40",
                                                        class: "mr-3"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createElementVNode("span", _hoisted_23, _toDisplayString(option.NumeroOpcion), 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"]),
                                                      _createElementVNode("div", null, [
                                                        _createElementVNode("div", _hoisted_24, _toDisplayString(option.NombreOpcion), 1),
                                                        (option.DescripcionOpcion)
                                                          ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(option.DescripcionOpcion), 1))
                                                          : _createCommentVNode("", true)
                                                      ])
                                                    ]),
                                                    (option.EsSeleccionada)
                                                      ? (_openBlock(), _createBlock(_component_v_chip, {
                                                          key: 0,
                                                          color: "success",
                                                          size: "small",
                                                          "prepend-icon": "mdi-check-circle"
                                                        }, {
                                                          default: _withCtx(() => _cache[62] || (_cache[62] = [
                                                            _createTextVNode(" Seleccionada ")
                                                          ])),
                                                          _: 1,
                                                          __: [62]
                                                        }))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_card_text, { class: "pa-4" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_row, null, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          md: "7"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _cache[63] || (_cache[63] = _createElementVNode("div", { class: "text-subtitle-2 mb-2" }, "Items incluidos:", -1)),
                                                            _createElementVNode("div", _hoisted_26, [
                                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getServicesSummary(option.DetalleOpcionID), (service, index) => {
                                                                return (_openBlock(), _createBlock(_component_v_chip, {
                                                                  key: index,
                                                                  size: "small",
                                                                  variant: "outlined",
                                                                  color: "primary",
                                                                  class: "ma-1"
                                                                }, {
                                                                  default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(service.name) + " (" + _toDisplayString(service.count) + ") ", 1)
                                                                  ]),
                                                                  _: 2
                                                                }, 1024))
                                                              }), 128))
                                                            ]),
                                                            _createElementVNode("div", _hoisted_27, " Total: " + _toDisplayString(getOptionItemsCount(option.DetalleOpcionID)) + " unidades ", 1)
                                                          ]),
                                                          _: 2,
                                                          __: [63]
                                                        }, 1024),
                                                        _createVNode(_component_v_col, {
                                                          cols: "12",
                                                          md: "5"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_card, {
                                                              variant: "outlined",
                                                              class: "pricing-card"
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createVNode(_component_v_card_text, { class: "pa-3" }, {
                                                                  default: _withCtx(() => [
                                                                    _createElementVNode("div", _hoisted_28, [
                                                                      _cache[64] || (_cache[64] = _createElementVNode("span", { class: "text-body-2" }, "Subtotal:", -1)),
                                                                      _createElementVNode("span", _hoisted_29, _toDisplayString(formatCurrency(option.Subtotal)), 1)
                                                                    ]),
                                                                    (option.MontoDescuento > 0)
                                                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                                                          _cache[65] || (_cache[65] = _createElementVNode("span", { class: "text-body-2" }, "Descuento:", -1)),
                                                                          _createElementVNode("span", _hoisted_31, "-" + _toDisplayString(formatCurrency(option.MontoDescuento)), 1)
                                                                        ]))
                                                                      : _createCommentVNode("", true),
                                                                    _createVNode(_component_v_divider, { class: "my-2" }),
                                                                    _createElementVNode("div", _hoisted_32, [
                                                                      _cache[66] || (_cache[66] = _createElementVNode("span", { class: "text-h6 font-weight-bold" }, "Total:", -1)),
                                                                      _createElementVNode("span", _hoisted_33, _toDisplayString(formatCurrency(option.TotalConDescuento)), 1)
                                                                    ])
                                                                  ]),
                                                                  _: 2
                                                                }, 1024)
                                                              ]),
                                                              _: 2
                                                            }, 1024)
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_btn, {
                                                      variant: "outlined",
                                                      color: "primary",
                                                      size: "small",
                                                      class: "mt-2",
                                                      onClick: ($event: any) => (selectOption(option))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { start: "" }, {
                                                          default: _withCtx(() => _cache[67] || (_cache[67] = [
                                                            _createTextVNode("mdi-check")
                                                          ])),
                                                          _: 1,
                                                          __: [67]
                                                        }),
                                                        _cache[68] || (_cache[68] = _createTextVNode(" Seleccionar esta opción "))
                                                      ]),
                                                      _: 2,
                                                      __: [68]
                                                    }, 1032, ["onClick"]),
                                                    _createVNode(_component_v_btn, {
                                                      variant: "text",
                                                      color: "primary",
                                                      size: "small",
                                                      class: "mt-2",
                                                      onClick: ($event: any) => (viewFullOptionDetails(option))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, { start: "" }, {
                                                          default: _withCtx(() => _cache[69] || (_cache[69] = [
                                                            _createTextVNode("mdi-eye")
                                                          ])),
                                                          _: 1,
                                                          __: [69]
                                                        }),
                                                        _cache[70] || (_cache[70] = _createTextVNode(" Ver detalles completos "))
                                                      ]),
                                                      _: 2,
                                                      __: [70]
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["class"])
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128))
                                    ]),
                                    _: 1
                                  }))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, { class: "pa-6 bg-grey-lighten-5" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_btn, {
                        color: "success",
                        variant: "flat",
                        "prepend-icon": "mdi-printer",
                        onClick: _cache[6] || (_cache[6] = ($event: any) => (generatePdf()))
                      }, {
                        default: _withCtx(() => _cache[71] || (_cache[71] = [
                          _createTextVNode(" Imprimir opciónes ")
                        ])),
                        _: 1,
                        __: [71]
                      }),
                      (selectedOpcion.value.EstadoOpcion === 'Pendiente')
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 0,
                            color: "warning",
                            variant: "tonal",
                            "prepend-icon": "mdi-clock-plus",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (extendExpiration(selectedOpcion.value)))
                          }, {
                            default: _withCtx(() => _cache[72] || (_cache[72] = [
                              _createTextVNode(" Extender Expiración ")
                            ])),
                            _: 1,
                            __: [72]
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        color: "grey",
                        variant: "text",
                        onClick: closeDetailsModal
                      }, {
                        default: _withCtx(() => _cache[73] || (_cache[73] = [
                          _createTextVNode(" Cerrar ")
                        ])),
                        _: 1,
                        __: [73]
                      }),
                      (selectedOpcion.value.EstadoOpcion === 'Seleccionada' && selectedOpcion.value.CotizacionGeneradaID)
                        ? (_openBlock(), _createBlock(_component_v_btn, {
                            key: 1,
                            color: "success",
                            variant: "flat",
                            size: "large",
                            "prepend-icon": "mdi-file-document-check",
                            onClick: _cache[8] || (_cache[8] = ($event: any) => (goToCotizacion(selectedOpcion.value.CotizacionGeneradaID)))
                          }, {
                            default: _withCtx(() => _cache[74] || (_cache[74] = [
                              _createTextVNode(" Ver Cotización Final ")
                            ])),
                            _: 1,
                            __: [74]
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_dialog, {
        modelValue: fullDetailsModal.value,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((fullDetailsModal).value = $event)),
        "max-width": "1000",
        scrollable: ""
      }, {
        default: _withCtx(() => [
          (selectedFullOption.value)
            ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_toolbar, {
                    color: "secondary",
                    dark: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_toolbar_title, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => _cache[75] || (_cache[75] = [
                              _createTextVNode("mdi-format-list-bulleted-square")
                            ])),
                            _: 1,
                            __: [75]
                          }),
                          _createTextVNode(" " + _toDisplayString(selectedFullOption.value.NombreOpcion) + " - Detalles Completos ", 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        icon: "",
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (fullDetailsModal.value = false))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, null, {
                            default: _withCtx(() => _cache[76] || (_cache[76] = [
                              _createTextVNode("mdi-close")
                            ])),
                            _: 1,
                            __: [76]
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_card_text, {
                    class: "pa-6",
                    style: {"max-height":"600px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getItemsGroupedByService(selectedFullOption.value.DetalleOpcionID), (service, serviceName) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: serviceName,
                          class: "mb-6"
                        }, [
                          _createElementVNode("h3", _hoisted_34, [
                            _createVNode(_component_v_icon, {
                              color: "primary",
                              class: "mr-2"
                            }, {
                              default: _withCtx(() => _cache[77] || (_cache[77] = [
                                _createTextVNode("mdi-folder")
                              ])),
                              _: 1,
                              __: [77]
                            }),
                            _createTextVNode(" " + _toDisplayString(serviceName), 1)
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(service, (section, sectionName) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: sectionName,
                              class: "ml-4 mb-4"
                            }, [
                              _createElementVNode("h4", _hoisted_35, [
                                _createVNode(_component_v_icon, {
                                  size: "small",
                                  color: "secondary",
                                  class: "mr-2"
                                }, {
                                  default: _withCtx(() => _cache[78] || (_cache[78] = [
                                    _createTextVNode("mdi-folder-outline")
                                  ])),
                                  _: 1,
                                  __: [78]
                                }),
                                _createTextVNode(" " + _toDisplayString(sectionName), 1)
                              ]),
                              _createVNode(_component_v_list, {
                                density: "compact",
                                class: "ml-4"
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section, (item) => {
                                    return (_openBlock(), _createBlock(_component_v_list_item, {
                                      key: item.ItemOpcionID,
                                      class: "mb-2"
                                    }, {
                                      prepend: _withCtx(() => [
                                        _createVNode(_component_v_icon, {
                                          color: "secondary",
                                          size: "small",
                                          class: "mt-1"
                                        }, {
                                          default: _withCtx(() => _cache[79] || (_cache[79] = [
                                            _createTextVNode("mdi-cube-outline")
                                          ])),
                                          _: 1,
                                          __: [79]
                                        })
                                      ]),
                                      append: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_39, _toDisplayString(formatCurrency(item.Subtotal)), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_list_item_title, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_chip, {
                                              color: "primary",
                                              size: "x-small",
                                              class: "mr-2 font-weight-bold"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(item.Cantidad) + "x", 1)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createTextVNode(" " + _toDisplayString(item.NombreItem), 1)
                                          ]),
                                          _: 2
                                        }, 1024),
                                        _createVNode(_component_v_list_item_subtitle, null, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_36, [
                                              _createTextVNode(_toDisplayString(formatCurrency(item.PrecioUnitario)) + " c/u ", 1),
                                              (item.Cantidad > 1)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_37, " × " + _toDisplayString(item.Cantidad) + " = " + _toDisplayString(formatCurrency(item.Subtotal)), 1))
                                                : _createCommentVNode("", true)
                                            ]),
                                            (item.Descripcion)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_38, "— " + _toDisplayString(item.Descripcion), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_divider),
                  _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_spacer),
                      _createVNode(_component_v_btn, {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (fullDetailsModal.value = false))
                      }, {
                        default: _withCtx(() => _cache[80] || (_cache[80] = [
                          _createTextVNode("Cerrar")
                        ])),
                        _: 1,
                        __: [80]
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_v_snackbar, {
        modelValue: snackbar.value.show,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((snackbar.value.show) = $event)),
        color: snackbar.value.color,
        timeout: "3000",
        location: "top"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(snackbar.value.message), 1)
        ]),
        _: 1
      }, 8, ["modelValue", "color"]),
      _createVNode(_component_v_dialog, {
        modelValue: reloadDialog.value,
        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((reloadDialog).value = $event)),
        "max-width": "420",
        persistent: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { class: "text-h6 pt-5 px-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => _cache[81] || (_cache[81] = [
                      _createTextVNode("mdi-refresh")
                    ])),
                    _: 1,
                    __: [81]
                  }),
                  _cache[82] || (_cache[82] = _createTextVNode(" Actualizar opciones "))
                ]),
                _: 1,
                __: [82]
              }),
              _createVNode(_component_v_card_text, { class: "px-6" }, {
                default: _withCtx(() => _cache[83] || (_cache[83] = [
                  _createTextVNode(" Acabas de crear nuevas opciones de cotización. ¿Deseas recargar la lista para ver las opciones actualizadas? ")
                ])),
                _: 1,
                __: [83]
              }),
              _createVNode(_component_v_card_actions, { class: "pa-4" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    variant: "text",
                    onClick: _cache[14] || (_cache[14] = ($event: any) => (reloadDialog.value = false))
                  }, {
                    default: _withCtx(() => _cache[84] || (_cache[84] = [
                      _createTextVNode("No, mantener")
                    ])),
                    _: 1,
                    __: [84]
                  }),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "elevated",
                    onClick: confirmReload
                  }, {
                    default: _withCtx(() => _cache[85] || (_cache[85] = [
                      _createTextVNode("Sí, actualizar")
                    ])),
                    _: 1,
                    __: [85]
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})